import { Token } from '@pancakeswap/sdk'
import { AutoRow, Flex, Heading, Skeleton, Tag, useTooltip, FarmMultiplierInfo } from '@pancakeswap/uikit'
import { FarmWidget } from '@pancakeswap/widgets-internal'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import { TokenPairImage } from 'components/TokenImage'
import { styled } from 'styled-components'

const { FarmAuctionTag, StableFarmTag, V2Tag, V3FeeTag } = FarmWidget.Tags

type ExpandableSectionProps = {
  lpLabel?: string
  multiplier?: string
  isCommunityFarm?: boolean
  token: Token
  quoteToken: Token
  boosted?: boolean
  isStable?: boolean
  version: 3 | 2
  feeAmount?: FeeAmount
  pid?: number
  farmCakePerSecond?: string
  totalMultipliers?: string
}

const Wrapper = styled(Flex)`
  gap: 24px;
  svg {
    margin-right: 4px;
  }
  h2 {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`

const MultiplierTag = styled(Tag)`
  margin-left: 4px;
`

const CardHeading: React.FC<React.PropsWithChildren<ExpandableSectionProps>> = ({
  lpLabel,
  multiplier,
  isCommunityFarm,
  token,
  quoteToken,
  isStable,
  version,
  feeAmount,
  farmCakePerSecond,
  totalMultipliers,
}) => {
  const isReady = multiplier !== undefined

  return (
    <Wrapper alignItems="center" mb="12px">
      <TokenPairImage variant="inverted" primaryToken={token} secondaryToken={quoteToken} width={64} height={64} />
      <Heading>{lpLabel}</Heading>
      {/* {isReady ? (
        <TokenPairImage variant="inverted" primaryToken={token} secondaryToken={quoteToken} width={64} height={64} />
      ) : (
        <Skeleton mr="8px" width={63} height={63} variant="circle" />
      )}
      <Flex flexDirection="column" alignItems="flex-end" width="100%">
        {isReady ? (
          <Heading mb="4px">{lpLabel?.split(' ')?.[0] ?? ''}</Heading>
        ) : (
          <Skeleton mb="4px" width={60} height={18} />
        )}
        <AutoRow gap="4px" justifyContent="flex-end">
          {isReady && isStable ? <StableFarmTag /> : version === 2 ? <V2Tag /> : null}
          {isReady && version === 3 && <V3FeeTag feeAmount={feeAmount} />}
          {isReady && boosted && <BoostedTag />}
          {isReady && isCommunityFarm && <FarmAuctionTag mr="-4px" />}
        </AutoRow>
      </Flex> */}
    </Wrapper>
  )
}

export default CardHeading
